import { FirmContext } from "../contexts/AuthContext";

export const canChangeFirm = (
  firmContext: FirmContext | null | undefined
): firmContext is FirmContext => {
  if (!firmContext) return false;
  return firmContext.roleName === "super_admin" || firmContext.roleName === "super_analyst";
};

export const canManageFirmUsers = (firmContext: FirmContext | null | undefined): boolean => {
  if (!firmContext?.permissions) return false;
  // Super admins have all permissions
  if (firmContext.permissions.super_admin) return true;
  // Check specific permissions - for admin only
  return !!firmContext.permissions.organization?.manage_users;
};

export const canAssignAnalysts = (firmContext: FirmContext | null | undefined): boolean => {
  if (!firmContext?.permissions) return false;
  if (firmContext.permissions.super_admin) return true;
  return !!firmContext.permissions.case_actions?.assign_analyst;
};

export const canAssignQC = (firmContext: FirmContext | null | undefined): boolean => {
  if (!firmContext?.permissions) return false;
  return !!firmContext.permissions.super_admin;
};
